import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommunicationService } from 'app/_services/communication.service';
import { WidgetService } from 'app/_services/widget.service';
import { AppComponent } from 'app/app.component';
import { ISettings } from 'app/_models/ISettings';
import { IWidget } from 'app/_models/IWidget';
import { RADController } from 'app/_controllers/radController';
import { IWidgetRow } from 'app/_models/IWidgetRow';
import { IconDefinition as IconDefinitionSolid, faArrowsLeftRight, faArrowUp, faArrowDown, faArrowTrendDown, faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition as IconDefinitionRegular } from '@fortawesome/free-regular-svg-icons';
import { IWidgetExpanded } from 'app/_models/IWidgetExpanded';
import { WidgetController } from 'app/_controllers/widgetController';

@Component({
  selector: 'widget-expanded',
  templateUrl: './widget-expanded.component.html',
  styleUrls: ['./widget-expanded.component.css']
})
export class WidgetExpandedComponent implements OnInit {
  //#region Fields & Icons 
  @Input() settings!: ISettings;
  @Input() userId!: string;
  @Input() nodeId!: string;
  @Input() widgets!: IWidget[];
  widgetData: IWidget[] = [];
  widgetRows!: IWidgetRow[][];
  maximised: boolean = false;
  widgetsLoaded: boolean = false;
  i!: number;
  maxRows: number = 0;
  maxCols: number = 0;
  gridItems: IWidgetExpanded[] = [];
  widgetsGridLoaded = false;
  faArrowsLeftRight: IconDefinitionSolid = faArrowsLeftRight;
  faArrowUp: IconDefinitionSolid = faArrowUp;
  faArrowDown: IconDefinitionSolid = faArrowDown;
  faArrowTrendDown: IconDefinitionSolid = faArrowTrendDown;
  faArrowTrendUp: IconDefinitionSolid = faArrowTrendUp;
  //#endregion

  constructor(    
    private communicationService: CommunicationService,
    private widgetController: WidgetController
  ) { }
  
  ngOnInit(): void {    
    this.widgetRows = this.widgetController.buildWidgetRows(this.widgets, this.maximised);  
    this.getGridDimensions();  
  }   

  toggleWidgetSize(): void {    
    this.widgetsLoaded = false;
    this.communicationService.toggleMaxWidgets();
    this.widgetRows = [];    
  }  

  getGridDimensions(): void {
    this.widgets.forEach(widget => {
      if (!widget.expandedPosition) return;

      let parts = widget.expandedPosition.split(',').map(n => parseInt(n.trim(), 10));
      let row = parts[0];
      let col = parts[1];
      let colSpan = parts[2] ?? 1;
      let rowSpan = parts[3] ?? 1;
      let rowEnd = row + rowSpan - 1;
      let colEnd = col + colSpan - 1;

      if (rowEnd > this.maxRows) this.maxRows = rowEnd;
      if (colEnd > this.maxCols) this.maxCols = colEnd;
      if (widget.backGroundColor == '' && (!widget.type.includes('Chart') && widget.type != 'RAG' )) widget.backGroundColor = 'var(--green)';/* && widget.type != 'Progress Bar' */      

      let height = '150px';      
      if (rowSpan == 2) {
        height = '300px';
      }

      if (rowSpan == 3) {
        height = '450px';
      }

      if (rowSpan == 4) {
        height = '600px';
      }

      this.gridItems.push({
        widget: widget,
        row: row,
        gridColumn: `${col ? col : this.maxCols} / span ${colSpan}`,
        gridRow: `${row} / span ${rowSpan}`,
        height: height,
        classes: [`col-span-${colSpan}`, `row-span-${rowSpan}`]
      });
    });

    this.gridItems = this.gridItems.sort((a, b) => a.row - b.row);   
    this.widgetsGridLoaded = true;              
  }  

  calculatePercentage(min: number, max: number, value: number): string {      
    return `${((value - min) / (max - min)) * 100}%`;
  }
}